import React, { useEffect, useState } from "react"
import { getSrc } from "gatsby-plugin-image"

import { Tabs } from "@components/common/tabs/Tabs"
import { Video } from "@components/common/video/Video"
import { AnimateWrapper } from "@components/main/animate-wrapper/AnimateWrapper"

import Arrow from "@assets/icons/arrow.inline.svg"
import { Props } from "./TabGallery.interface"
import * as s from "./TabGallery.module.scss"

export const TabGallery = ({ data }: Props) => {
  const [menuOpen, setMenuOpen] = useState(false)
  const tabs = data.tabContent
  const handleOpenMenu = () => {
    setMenuOpen(prev => {
      return !prev
    })
  }

  const arrowClass = menuOpen
    ? s.tabGallery__label___arrowOpen
    : s.tabGallery__label___arrow

  useEffect(() => {
    return setMenuOpen(prev => {
      return !prev
    })
  }, [])

  const addBreakpoint = text => {
    const stringMidpoint = text.split(" ")
    const arrayMidpoint = Math.ceil(stringMidpoint.length / 2)
    return (
      <>
        {stringMidpoint.map((text, idx) => {
          {
            return arrayMidpoint < 2 ? (
              <React.Fragment key={idx}>
                {text} <br />
              </React.Fragment>
            ) : (
              <React.Fragment key={idx}>{text} </React.Fragment>
            )
          }
        })}
      </>
    )
  }

  return (
    <>
      <AnimateWrapper>
        <div className={s.tabGallery}>
          <Tabs
            onClick={() => handleOpenMenu()}
            className={menuOpen && s.tabGallery__openMenu}
            controlledTab={true}
          >
            {tabs.map((tabs, i) => {
              return (
                <div
                  key={i}
                  id={i}
                  label={
                    <div className={`${s.tabGallery__label}`}>
                      <span className={s.tabGallery__label___title}>
                        {addBreakpoint(tabs.tabTitle)}
                      </span>

                      <span className={s.tabGallery__label___button}>
                        <Arrow className={arrowClass} />
                      </span>
                    </div>
                  }
                >
                  {tabs.tabBillboard &&
                    tabs.tabBillboard.mediaType === "image" && (
                      <div
                        role="image"
                        aria-label={tabs.tabBillboard?.altText}
                        className={s.tabGallery__image}
                        style={{
                          backgroundImage: `url(${tabs.tabBillboard.localFile ? getSrc(tabs.tabBillboard?.localFile) : tabs.tabBillboard.sourceUrl})`,
                        }}
                      >
                        <div className={s.tabGallery__image___usp}>
                          {tabs.uniqueSellingPoints &&
                            tabs.uniqueSellingPoints.map((usp, idx) => (
                              <span
                                key={idx}
                                className={s.tabGallery__image___uspBox}
                              >
                                {usp.uniqueSellingPoint}
                              </span>
                            ))}
                        </div>
                      </div>
                    )}

                  {tabs.tabBillboard &&
                    tabs.tabBillboard.mediaType === "file" && (
                      <div className={s.tabGallery__videoWrapper}>
                        <Video
                          className={s.tabGallery__video}
                          url={tabs.tabBillboard.sourceUrl}
                          cover={true}
                        />
                      </div>
                    )}
                </div>
              )
            })}
          </Tabs>
        </div>
      </AnimateWrapper>

      <div className={s.tabGallery__cover} />
    </>
  )
}
